import { CompSelectBoxOption } from '@/components/common/CompSelectBox.vue';

interface Options {
	name: string,
	hasAll: boolean,
	noBrackets: boolean,
	data: {id: string; value: string; dispaly: string}[] // CheckBoxComponent 에서 dispaly 라고 명시했기 때문에 어쩔 수 없다...
}

export interface SearchFormOptions {
	saleStatusOptions: Options;
	searchKeywordTypes: CompSelectBoxOption<string>[];
	periodOption: {
		name: string;
		periodTypes: string[];
		period: string;
	}
	deliveryCycleOptions: Options;
	productStatusTypes: CompSelectBoxOption<string>[];
	displayStatusTypes: CompSelectBoxOption<string>[];
}

const getI18nPath = (key: string): string => {
	return `RECURRINGPAYMENTS_PRODUCT_${key}`;
}

export const DEFAULT_STATE = {
	mallSelectDisabled: false,
	mallNo: 0,
	searchKeywordType: 'PRODUCT_NAME',
	searchKeywordValue: '',
	saleStatus: 'ALL',
	deliveryCycleStatus: 'ALL',
	productStatus: 'ALL',
	displayStatus: 'ALL',
	partnerCandidateDataList: [],
	partnerNo: 0,
} as const;

// 고정된 체크박스 옵션들이나 select 옵션들
export const options = (): SearchFormOptions => (
	{
	// 판매 상태
	saleStatusOptions: {
		name: 'saleStatusOptions',
		hasAll: true,
		noBrackets: true,
		data: [
			{
				id: 'ALL',
				value: 'ALL',
				dispaly: 'COMMON_ALL_CHECK'
			},
			{
				id: 'WAITING_SALE',
				value: 'READY',
				dispaly: getI18nPath('WAITING_SALE'),
			},
			{
				id: 'ON_PRE_SALE',
				value: 'RESERVATION_ONSALE',
				dispaly: getI18nPath('ON_PRE_SALE'),
			},
			{
				id: 'ON_SALE',
				value: 'ONSALE',
				dispaly: getI18nPath('ON_SALE'),
			},
			{
				id: 'END_SALE',
				value: 'FINISHED',
				dispaly: getI18nPath('END_SALE'),
			},
			{
				id: 'STOP_SELLING',
				value: 'STOP',
				dispaly: getI18nPath('STOP_SELLING')
			},
			{
				id: 'PROHIBITION_SALE',
				value: 'PROHIBITION',
				dispaly: getI18nPath('PROHIBITION_SALE')
			}
		]
	},

	// 검색어 타입
	searchKeywordTypes: [
			{
				value: 'PRODUCT_NAME',
				name: getI18nPath('PRODUCT_NAME'),
			},
			{
				value: 'PRODUCT_NO',
				name: getI18nPath('PRODUCT_NO'),
			},
	],

	// 등록일 dateCalender 옵션 설정
	periodOption: {
		name: 'registrationDate',
		periodTypes: ['td', '1w', '1m', '3m', '6m', '1y'],
		period: '3m',
	},

	// 배송주기
	deliveryCycleOptions: {
		name: 'deliveryCycleOptions',
		hasAll: true,
		noBrackets: true,
		data: [
			{
				id: 'ALL',
				value: 'ALL',
				dispaly: 'COMMON_ALL_CHECK',
			},
			{
				id: 'ONE_MONTH',
				value: 'ONE_MONTH',
				dispaly: getI18nPath('ONE_MONTH'),
			},
			{
				id: 'TWO_MONTH',
				value: 'TWO_MONTH',
				dispaly: getI18nPath('TWO_MONTH'),
			},
			{
				id: 'THREE_MONTH',
				value: 'THREE_MONTH',
				dispaly: getI18nPath('THREE_MONTH'),
			},
			{
				id: 'FOUR_MONTH',
				value: 'FOUR_MONTH',
				dispaly: getI18nPath('FOUR_MONTH'),
			},
			{
				id: 'FIVE_MONTH',
				value: 'FIVE_MONTH',
				dispaly: getI18nPath('FIVE_MONTH'),
			},
			{
				id: 'SIX_MONTH',
				value: 'SIX_MONTH',
				dispaly: getI18nPath('SIX_MONTH'),
			},
		]
	},

	// 상품상태
	productStatusTypes: [
		{
			name: getI18nPath('WAITING_REGISTRATION'),
			value: 'REGISTRATION_READY',
		},
		{
			name: getI18nPath('WAITING_APPROVAL_AFTER_MODIFY'),
			value: 'AFTER_APPROVAL_READY',
		},
		{
			name: getI18nPath('APPROVAL_REJECTION_AFTER_MODIFY'),
			value: 'AFTER_APPROVAL_REJECTION',
		},
	],

	// 전시상태
	displayStatusTypes: [
		{
			name: getI18nPath('DISPLAY_POSSIBLE'),
			value: 'Y',
		},
		{
			name: getI18nPath('NOT_DISPLAY'),
			value: 'N',
		},
	]
})